<template>
  <div class="group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup'
}
</script>

<style scoped>
.group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
